import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createVNode as _createVNode, toDisplayString as _toDisplayString, createElementVNode as _createElementVNode, withCtx as _withCtx, createTextVNode as _createTextVNode, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "flex w-full shrink-0 cursor-pointer items-center gap-2 md:max-w-[200px] 2xl:shrink" }
const _hoisted_2 = { class: "flex flex-col" }
const _hoisted_3 = { class: "text-left text-lg leading-[1.2] font-medium" }
const _hoisted_4 = { class: "text-muted-foreground text-left text-[10px] leading-none" }

import type { Company } from '@/types';
    import {
        Dialog,
        DialogContent,
        DialogBody,
        DialogHeader,
        DialogTitle,
        DialogTrigger,
    } from '@/components/ui/dialog';
    import { useI18n } from 'vue-i18n';
    import { CircleDollarSign } from 'lucide-vue-next';
    import { formatCurrency } from '@/utils/helpers';
    import CustomerInvoicesTable from './CustomerInvoicesTable.vue';

    
export default /*@__PURE__*/_defineComponent({
  __name: 'CustomerInvoices',
  props: {
    company: {}
  },
  setup(__props: any) {

    const { t } = useI18n();

    const props = __props;

return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Dialog), null, {
    default: _withCtx(() => [
      _createVNode(_unref(DialogTrigger), { "as-child": "" }, {
        default: _withCtx(() => [
          _createElementVNode("button", _hoisted_1, [
            _createVNode(_unref(CircleDollarSign), { class: "text-destructive size-6 shrink-0" }),
            _createElementVNode("div", _hoisted_2, [
              _createElementVNode("span", _hoisted_3, _toDisplayString(_ctx.company.services?.fixed_price
                            ? _unref(formatCurrency)(props.company.services.fixed_price)
                            : 'N/A'), 1),
              _createElementVNode("span", _hoisted_4, _toDisplayString(_unref(t)(
                                `dashboards.customer_stats.price_frequency.${props.company.services?.price_frequency}`,
                            )), 1)
            ])
          ])
        ]),
        _: 1
      }),
      _createVNode(_unref(DialogContent), { class: "sm:max-w-3xl" }, {
        default: _withCtx(() => [
          _createVNode(_unref(DialogHeader), null, {
            default: _withCtx(() => [
              _createVNode(_unref(DialogTitle), null, {
                default: _withCtx(() => [
                  _createTextVNode(_toDisplayString(_unref(t)('dashboards.invoices.title')), 1)
                ]),
                _: 1
              })
            ]),
            _: 1
          }),
          _createVNode(_unref(DialogBody), null, {
            default: _withCtx(() => [
              _createVNode(CustomerInvoicesTable, {
                company: props.company
              }, null, 8, ["company"])
            ]),
            _: 1
          })
        ]),
        _: 1
      })
    ]),
    _: 1
  }))
}
}

})